export default __webpack_public_path__ + "maps-examples-building-extrusions-thumbnail-480-378153627c2ebcec32e5cde953170430.webp";